import { useSessionStorage } from 'usehooks-ts';
import { isEmpty } from 'lodash';

import {
  RecordsWithTimestamp,
  SAVED_INSTANCES_KEY,
  SAVED_SEARCHES_KEY,
} from '@app/components';

import { UserSearchDto } from '../useRecentActivityRequests';
import {
  useSaveSavedInstancesMutation,
  useSaveSavedSearchesMutation,
} from '../useSavedActivityRequests';

export const useSavedActivityTransfer = () => {
  const [savedGuestSearches, setSavedGuestSearches] = useSessionStorage<
    UserSearchDto[]
  >(SAVED_SEARCHES_KEY, []);
  const [savedInstances, setSavedInstances] = useSessionStorage<
    RecordsWithTimestamp[]
  >(SAVED_INSTANCES_KEY, []);

  const transferSavedRecordsMutation = useSaveSavedInstancesMutation();
  const transferSavedSearchesMutation = useSaveSavedSearchesMutation();

  const transferSavedActivity = (systemId: string) => {
    if (!isEmpty(savedInstances)) {
      transferSavedRecordsMutation.mutate(
        {
          savedInstances,
          systemId,
        },
        { onSuccess: () => setSavedInstances([]) }
      );
    }

    if (!isEmpty(savedGuestSearches)) {
      transferSavedSearchesMutation.mutate(
        {
          searches: savedGuestSearches,
          systemId,
        },
        { onSuccess: () => setSavedGuestSearches([]) }
      );
    }
  };

  return {
    isLoading:
      transferSavedSearchesMutation.isLoading ||
      transferSavedRecordsMutation.isLoading,
    transfer: transferSavedActivity,
  };
};
